import { render, staticRenderFns } from "./uploadHelpFile.vue?vue&type=template&id=32362d94&scoped=true&"
import script from "./uploadHelpFile.vue?vue&type=script&lang=js&"
export * from "./uploadHelpFile.vue?vue&type=script&lang=js&"
import style0 from "./uploadHelpFile.vue?vue&type=style&index=0&id=32362d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32362d94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32362d94')) {
      api.createRecord('32362d94', component.options)
    } else {
      api.reload('32362d94', component.options)
    }
    module.hot.accept("./uploadHelpFile.vue?vue&type=template&id=32362d94&scoped=true&", function () {
      api.rerender('32362d94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/System/helpDoc/uploadHelpFile.vue"
export default component.exports